import { useStaticQuery } from 'gatsby';
const orderTypes = (types, order) => {
  types.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));
  return types;
};
const useDisplayBrands = (exclude, order) => {
  const {
    brands,
    brand_types
  } = useStaticQuery(query);
  const usedTypes = [];
  brands.nodes.forEach(_ref => {
    let {
      brand
    } = _ref;
    if (!usedTypes.includes(brand.type.type) && !exclude.includes(brand.type.type)) {
      usedTypes.push(brand.type.type);
    }
  });
  return {
    displayTypes: orderTypes(brand_types.nodes.filter(brand_type => usedTypes.includes(brand_type.type)), order),
    brands: brands
  };
};
export default useDisplayBrands;
const query = "799861118";